/**
 * Processes an image file to a circular PNG
 * @param {File} file - The image file to process
 * @returns {Promise<Blob>} - Processed circular PNG blob
 */
export const processImageToCircularPNG = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const size = Math.min(img.width, img.height);
        canvas.width = size;
        canvas.height = size;
        const startX = (img.width - size) / 2;
        const startY = (img.height - size) / 2;
        ctx.beginPath();
        ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();
        ctx.drawImage(img, startX, startY, size, size, 0, 0, size, size);
        canvas.toBlob(
          (blob) => (blob ? resolve(blob) : reject(new Error("Failed to create blob"))),
          "image/png",
          1.0
        );
      };
      img.onerror = () => reject(new Error("Failed to load image"));
      img.src = e.target.result;
    };
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });
};

/**
 * Validates image file
 * @param {File} file - The file to validate
 * @returns {Object} - { valid: boolean, error: string }
 */
export const validateImageFile = (file) => {
  if (!file) return { valid: false, error: null };
  
  if (!file.type.startsWith("image/")) {
    return { valid: false, error: "Please select an image file" };
  }
  
  if (file.size > 5 * 1024 * 1024) {
    return { valid: false, error: "Image size should be less than 5MB" };
  }
  
  return { valid: true, error: null };
};
